// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__Xait-","label":"Labeled_label__162J7","divider":"Labeled_divider__Gl5hz"};